import { Collapse } from "react-collapse";
import { styled } from "~/application/theme";

// @ts-ignore
export const DropdownCollapse = styled(Collapse, {});
